import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { useHttp } from "../../hook/http.hook";
import { units } from "./quantity-selector";


const cartAdapter = createEntityAdapter();

const cartStorage = JSON.parse(localStorage.getItem('cart'));

const initialState = cartAdapter.getInitialState({
    cart: cartStorage || [],
    // cartId: localStorage.getItem('cartId') || null,
    cartLoadingStatus: 'idle',
    cartTotal: 0,
    count: cartStorage ? Object.keys(cartStorage).length : 0,
    tableId: localStorage.getItem('tableId') || null
});

const calculateTotal = (cart, products) => {

    return cart.reduce((sum, cartItem) => {
        const product = products.find(product => product.id === cartItem.id);
        const modificators = cartItem?.modificators 
            ? cartItem.modificators.reduce((acc, arr) => acc + parseFloat(arr.price), 0) 
            : 0;

        let qty = cartItem.qty;

        return sum + (product ? (Number(modificators) + Number(product.price)) * qty : 0);
    }, 0);
};

export const createOrder = createAsyncThunk(
    'cart/createOrder',
    async () => {
        const { request } = useHttp();

        const cart = JSON.parse(localStorage.getItem('cart'));
        const table = localStorage.getItem('tableId');
        // const shipping = JSON.parse(localStorage.getItem('shipping'));
        // const payment = localStorage.getItem('payment');

        const response = await request(
            `order/create`,
            `POST`,
            JSON.stringify({
                table: table,
                cart: cart,
                // shipping: shipping,
                // payment: payment,
            })
        );
        
        return response;
    }
)

const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        setCartId(state, action) {
            state.cartId = action.payload
        },
        setCart(state, action) {
            state.cart = action.payload;
            state.count = state.cart.length;
            localStorage.setItem('cart', JSON.stringify(state.cart));
        },
        addToCart(state, action) {
            state.cart.push(action.payload);
            state.count = state.cart.length;
            localStorage.setItem('cart', JSON.stringify(state.cart));
        },
        setModificator(state, action) {
            const { productId, modificator, type } = action.payload;
            const product = state.cart.find(item => item.id === productId);
            
            if (product) {
                if (!product.modificators) {
                    product.modificators = [];
                }
        
                const index = product.modificators.findIndex(mod => mod.id === modificator.id);
                
                if (index === -1) {
                    if(type === 'radio' || type === 'default') {
                        product.modificators[0] = modificator;
                    } else {
                        product.modificators.push(modificator);
                    }
                } else {
                    product.modificators.splice(index, 1);
                }
        
                localStorage.setItem('cart', JSON.stringify(state.cart));
            }
        },
        incrementQuantity(state, action) {
            const { id } = action.payload;
            const item = state.cart.find(item => item.id === id);
            if (item) {
                const unit = units.find(u => u.id === item.unit);
                const incrementStep = unit && unit.precision === 1 ? 0.1 : unit.precision === 2 ? 10 : 1;
                item.qty += incrementStep;
                item.qty = parseFloat(item.qty.toFixed(unit.precision));
            localStorage.setItem('cart', JSON.stringify(state.cart));
            }
        },
        decrementQuantity(state, action) {
            const { id } = action.payload;
            const item = state.cart.find(item => item.id === id);
            if (item) {
                const unit = units.find(u => u.id === item.unit);
                const decrementStep = unit && unit.precision === 1 ? 0.1 : unit.precision === 2 ? 10 : 1;
        
               
                const minQty = decrementStep === 1 ? 1 : decrementStep;
                if (item.qty > minQty) {
                    item.qty -= decrementStep;
                    item.qty = parseFloat(item.qty.toFixed(unit.precision));
                } else {
                    
                    state.cart = state.cart.filter(cartItem => cartItem.id !== id);
                }
            }
            localStorage.setItem('cart', JSON.stringify(state.cart));
            state.count = state.cart.length;
        },
        setCurrentTotal(state, action) {
            const { products = [] } =  action.payload;

            state.cartTotal = calculateTotal(state.cart, products);
        },
        clearCart(state, action) {
            state.cart = [];
            state.cartId = null;
            state.cartTotal = 0;
            state.count = 0;
            localStorage.removeItem('cart');
        },
        setTable(state, action) {
            state.tableId = action.payload;
            localStorage.setItem('tableId', action.payload);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(createOrder.pending, state => {state.cartLoadingStatus = 'loading'})
            .addCase(createOrder.fulfilled, (state, action) => {
                state.cartLoadingStatus = 'idle';
            })
            .addCase(createOrder.rejected, state => {state.cartLoadingStatus = 'error'})
            .addDefaultCase(() => {})
    }
});

export const  { selectAll } = cartAdapter.getSelectors( state => state.cart );

const { reducer, actions } = cartSlice;

export default reducer;

export const {setCurrentTotal, clearCart, setCartId, addToCart, incrementQuantity, decrementQuantity, setCart, setTable, setModificator } = actions;